export const DEFAULT_WEIGHTS = {
    outcome: 1,
    interruption: 1,
    negativeFeedback: 1,
    confirmation: 0.5,
};
// What an interruption costs a sent decision point. A hold costs nothing: it
// never reached the member.
export const SEND_INTERRUPTION_COST = 0.3;
export const NEGATIVE_FEEDBACK = { dismissed: 0.3, not_now: 0.1, never: 1 };
/** Reward for one decision point. */
export function reward(input, weights = DEFAULT_WEIGHTS) {
    if (input.score === null)
        return null;
    return (weights.outcome * input.score -
        weights.interruption * input.interruptionCost -
        weights.negativeFeedback * input.negativeFeedback +
        weights.confirmation * input.confirmation);
}
//# sourceMappingURL=reward.js.map